import { SiteEquipmentStats_Read } from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

import { Nullable } from '~types/Nullable';

import { SiteBasic } from '../useSites/models';

export class SiteEquipmentStats {
  public static parse(proto: SiteEquipmentStats_Read): SiteEquipmentStats {
    return new SiteEquipmentStats(
      proto.id ?? '',
      dayjs(proto.created_at),
      dayjs(proto.updated_at),
      SiteBasic.parse(proto.site),
      proto.on_site_equipment_count,
      proto.en_route_equipment_count,
      proto.avg_onsite_time_minutes,
      proto.last_geofence_at ? dayjs(proto.last_geofence_at) : null,
    );
  }

  public get id() {
    return this._id;
  }

  public get createdAt() {
    return this._created_at;
  }

  public get updatedAt() {
    return this._updated_at;
  }

  public get site() {
    return this._site;
  }

  public get onSiteEquipmentCount() {
    return this._on_site_equipment_count;
  }

  public get enRouteEquipmentCount() {
    return this._en_route_equipment_count;
  }

  public get avgOnsiteTimeMinutes() {
    return this._avg_onsite_time_minutes;
  }

  public get lastGeofenceAt() {
    return this._last_geofence_at;
  }

  constructor(
    private _id: string,
    private _created_at: Dayjs,
    private _updated_at: Dayjs,
    private _site: SiteBasic,
    private _on_site_equipment_count: number,
    private _en_route_equipment_count: number,
    private _avg_onsite_time_minutes: number,
    private _last_geofence_at: Nullable<Dayjs>,
  ) {}
}
